import { AiJobDetails } from './ai-job-details';

export abstract class IAiJobsRepository {
  abstract get(): Promise<AiJobDetails[]>;
}
